import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f8f9fa;
`;

export const MainContent = styled.main`
  flex: 1;
  transition: all 0.3s ease;
  width: 100%;
  margin-left: 280px; /* Largura do sidebar */
  
  @media (max-width: 1024px) {
    margin-left: 0;
  }
`;

export const ContentWrapper = styled.div`
  padding: 32px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
  gap: 24px;

  @media (max-width: 968px) {
    flex-direction: column;
  }
`;

export const HeaderTitle = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #202124;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 968px) {
    width: 100%;
  }
`;

export const SearchBar = styled.input`
  padding: 10px 16px 10px 40px;
  border: 1px solid #dadce0;
  border-radius: 24px;
  font-size: 14px;
  min-width: 250px;
  background: #ffffff url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="%235F6368"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>') no-repeat 12px center;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #4285f4;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
  }

  @media (max-width: 968px) {
    width: 100%;
    min-width: auto;
  }
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 1px solid #dadce0;
  border-radius: 24px;
  background: #ffffff;
  color: #5f6368;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    border-color: #bdc1c6;
  }

  .material-icons {
    font-size: 18px;
  }
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border: none;
  border-radius: 24px;
  background: #4285f4;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #1967d2;
    box-shadow: 0 2px 8px rgba(66, 133, 244, 0.3);
  }

  .material-icons {
    font-size: 18px;
  }
`;

export const ProfilesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ProfileCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
`;

export const ProfileHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const ProfileAvatar = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4285f4 0%, #34a853 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
`;

export const ProfileStatus = styled.span<{ $color: string }>`
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.$color};
  background: ${(props) => `${props.$color}15`};
`;

export const ProfileInfo = styled.div`
  margin-bottom: 20px;
`;

export const ProfileName = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #202124;
  margin: 0 0 4px 0;
`;

export const ProfileCategory = styled.p`
  font-size: 14px;
  color: #5f6368;
  margin: 0;
`;

export const ProfileStats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 16px 0;
  border-top: 1px solid #e8eaed;
  border-bottom: 1px solid #e8eaed;
  margin-bottom: 20px;
`;

export const StatItem = styled.div`
  text-align: center;
`;

export const StatValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #202124;
  margin-bottom: 4px;
`;

export const StatLabel = styled.div`
  font-size: 11px;
  color: #5f6368;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ProfileActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionButton = styled.button<{ $secondary?: boolean }>`
  flex: ${(props) => (props.$secondary ? "0" : "1")};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid ${(props) => (props.$secondary ? "#dadce0" : "transparent")};
  border-radius: 8px;
  background: ${(props) => (props.$secondary ? "#ffffff" : "#4285f4")};
  color: ${(props) => (props.$secondary ? "#5f6368" : "#ffffff")};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => (props.$secondary ? "#f8f9fa" : "#1967d2")};
  }

  .material-icons {
    font-size: 18px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const EmptyStateIcon = styled.span`
  font-size: 80px;
  color: #dadce0;
  margin-bottom: 24px;
`;

export const EmptyStateTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #202124;
  margin: 0 0 8px 0;
`;

export const EmptyStateText = styled.p`
  font-size: 16px;
  color: #5f6368;
  margin: 0;
  text-align: center;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 24px;

  p {
    font-size: 16px;
    color: #5f6368;
  }
`;

export const LoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e8eaed;
  border-top-color: #4285f4;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
